import { handleActions } from "redux-actions";
import { ALLOCATION_DIMENSION } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    ListAllocationDimensionRequestAction,
    ListAllocationDimensionCompleteAction,
} from "actions/allocation-dimension";
import { IAllocationDimension } from "helpers/allocation-dimension";

export interface IListState extends IQuery<IAllocationDimension[]> {}
interface ISingleState extends IQuery<IAllocationDimension>, IMutate<IAllocationDimension> {
    isNew?: boolean;
}

export interface IState {
    list: IListState;
    single: ISingleState;
}

const initialState: IState = {
    list: {
        queryError: undefined,
        queryStatus: RequestStatus.Idle,
        result: [],
    },
    single: {
        queryError: undefined,
        queryStatus: RequestStatus.Active,
        mutateStatus: RequestStatus.Idle,
        mutateError: undefined,
        result: undefined,
        isNew: undefined,
    },
};

export const merchantAllocationDimension = handleActions<IState, any>(
    {
        [ALLOCATION_DIMENSION.LIST.REQUEST]: (state: IState, _action: ListAllocationDimensionRequestAction): IState => {
            return {
                ...state,
                list: {
                    ...initialState.list,
                    queryStatus: RequestStatus.Active,
                },
            };
        },
        [ALLOCATION_DIMENSION.LIST.COMPLETE]: (
            state: IState,
            action: ListAllocationDimensionCompleteAction,
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    queryError: action.payload instanceof Error ? action.payload : undefined,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
    } as any,
    initialState,
);
